export type Step = 'step1' | 'step2' | 'step3' | 'step4' | 'result'

export const dialogueAnswers = {
  sectionType: {
    yes: 'yes',
    no: 'no',
    unknown: 'unknown'
  },
  price: {
    middle: 'middle',
    high: 'high',
    low: 'low',
    undecided: 'undecided'
  },
  sect: {
    nothing: 'nothing'
  }
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace STEP {
  export const FIRST = 'step1'
  export const SECOND = 'step2'
  export const THIRD = 'step3'
  export const FOURTH = 'step4'
  export const RESULT = 'result'
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace QUESTION_STEP {
  export const SECTION_TYPE = STEP.FIRST
  export const PRICE = STEP.SECOND
  export const SECT = STEP.THIRD
  export const AREA = STEP.FOURTH
}
